import MatchBasicModel from "../../Football/Models/Match/MatchBasicModel";
import PlayerDetailedPointsModel from "./PlayerDetailedPointsModel";
import PlayerStatsMatchModel from "./PlayerStatsMatchModel";

export default class PlayerDetailedStatsModel {
  public matchId: string = null;
  public matchModel: MatchBasicModel = null;
  public points: PlayerDetailedPointsModel = new PlayerDetailedPointsModel();
  public stats: PlayerStatsMatchModel = new PlayerStatsMatchModel();
}
